import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, MessageService, PrimeTemplate } from "primeng/api";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { Bookings } from "src/app/models/bookings";
import { Billings } from "src/app/models/billings";
import { Comuni } from "src/app/models/comuni";
import { PARAM_COMUNI_PATH } from "src/app/constants/constants";
import { ComuniService } from "src/app/services/comuni.service";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";

import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { ButtonDirective } from "primeng/button";
import { TableModule } from "primeng/table";
import { NgxPaginationModule } from "ngx-pagination";
import { ConfirmDialog } from "primeng/confirmdialog";
import { TranslatePipe } from "@ngx-translate/core";

import { DynamicFiltersComponent } from "../../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-manage-comuni",
    templateUrl: "./manage-comuni.component.html",
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, Select, ButtonDirective, RouterLink, TableModule, NgxPaginationModule, ConfirmDialog, TranslatePipe]
})
export class ManageComuniComponent extends AbstractListController<Comuni, any> {
  protected comuniService: ComuniService;
  private messageService = inject(MessageService);
  protected confirmationService: ConfirmationService;

  title = "Paesi";
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  readonly roomDialog = signal<boolean>(false);
  booking: Bookings;
  readonly billing = signal<Billings>(undefined);
  readonly selectedSkills = signal<any[]>(undefined);

  constructor() {
    const comuniService = inject(ComuniService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(comuniService, confirmationService, router, route, PARAM_COMUNI_PATH);
    this.comuniService = comuniService;
    this.confirmationService = confirmationService;

    this.cols.set([{ field: "name", header: "Nome" }]);
    this.colsFilter.set([{ field: "name", header: "Nome", type: "string" }]);

    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({
        label: this.cols()[i].header,
        value: this.cols()[i],
      }); return [...a]; });
    }
  }

  deactive(billing: Billings) {
    const formData = new FormData();

    formData.set("is_active", "0");
    this.comuniService.update(formData, billing.id).subscribe(
      (res) => {
        this.load();
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Attenzione",
          detail: "Aggiornato con success",
        });
      },
      (error) => (this.error.set(error))
    );
  }

  active(billing: Billings) {
    const formData = new FormData();

    formData.set("is_active", "1");

    this.comuniService.update(formData, billing.id).subscribe(
      (res) => {
        this.load();
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Attenzione",
          detail: "Aggiornato con success",
        });
      },
      (error) => (this.error.set(error))
    );
  }

  edit(billing: Billings) {
    this.billing.set({ ...billing });
    this.selectedSkills.set(JSON.parse("" + this.billing().skills + ""));
    this.roomDialog.set(true);
  }
}
